import React, { Component } from 'react'
import { connect } from 'react-redux'

import { DistribucionPorCondicionDetallesView } from '../components/DistribucionPorCondicionDetallesView'

class DistribucionPorCondicionDetalles extends Component {
  render () {
    return <DistribucionPorCondicionDetallesView />
  }
}

const withRedux = connect(null, null)

export default withRedux(DistribucionPorCondicionDetalles)
